/* eslint-disable no-console */
import i18n from '@/config/client/i18n';

angular.module('core').run(coreRun);

/* @ngInject */
function coreRun(Facebook, push, $rootScope, $window, $log) {
  // Attempt to initialize Facebook SDK on first page load
  // If this fails, we'll try this again on successfull login
  Facebook.init();

  // Initialize the push service if available
  // It will check if user intended to enable push for this browser
  // and setup the service-worker and backend registration accordingly
  push.init();

  // Ensure i18n language persists across route changes
  // Sync language from database (if logged in) or cookie on route changes to prevent reverting to English
  $rootScope.$on('$stateChangeSuccess', () => {
    // Small delay to ensure cookie is accessible
    setTimeout(() => {
      try {
        // Check user locale from database first (takes priority for logged-in users)
        const userLocale =
          $window.user && $window.user.locale
            ? $window.user.locale.trim()
            : null;
        // Check cookie as fallback
        const cookieMatch = document.cookie.match(/i18n=([^;]+)/);
        const cookieLanguage = cookieMatch ? cookieMatch[1].trim() : null;

        // Determine target language: DB locale > Cookie > current i18n language (don't change if already correct)
        const targetLanguage = userLocale || cookieLanguage;

        $log.log(
          'Route change - User DB locale:',
          userLocale,
          'Cookie language:',
          cookieLanguage,
          'i18n language:',
          i18n.language,
          'Target:',
          targetLanguage,
        );

        // If we have a target language and it differs from current, change it
        if (targetLanguage && targetLanguage !== i18n.language) {
          $log.log(
            'Syncing i18n language on route change to:',
            targetLanguage,
            userLocale ? '(from database)' : '(from cookie)',
          );
          i18n.changeLanguage(targetLanguage).catch(err => {
            $log.error('Failed to change language on route change:', err);
          });
        } else if (!targetLanguage && i18n.language && i18n.language !== 'en') {
          // If no DB locale or cookie but i18n has a non-English language, save it to cookie
          $log.log(
            'No DB locale or cookie found, saving current language to cookie:',
            i18n.language,
          );
          const maxAge = 60 * 60 * 24 * 365; // 1 year in seconds
          document.cookie = `i18n=${i18n.language}; path=/; max-age=${maxAge}; SameSite=Lax`;
        } else if (targetLanguage && targetLanguage === i18n.language) {
          $log.log('Route change - Language already correct:', i18n.language);
        }
      } catch (err) {
        $log.error('Error checking language on route change:', err);
      }
    }, 10);
  });
}
